module.exports = __webpack_public_path__ + "static/media/logo_qualdo.48061a72.svg";